import { func, oneOf } from "prop-types";
import { useTranslation } from "react-i18next";
import { PriceModifierModes } from "@repo/utils";
import { NavigationSwitch } from "@components";

export const ModeSwitch = ({
  value,
  onChange,
}) => {
  const { t } = useTranslation();
  
  const modeValues = [
    { value: PriceModifierModes.PERCENT, label: t(`proposal_parts.price_modifier_modes.${PriceModifierModes.PERCENT}`) },
    { value: PriceModifierModes.FIXED_PRICE, label: t(`proposal_parts.price_modifier_modes.${PriceModifierModes.FIXED_PRICE}`) },
  ];
  
  return (
    <NavigationSwitch
      values={modeValues}
      value={value}
      onChange={(_, newValue) => onChange(newValue)}
      lighter
      className="mb-4 w-half"
    />
  )
}

ModeSwitch.propTypes = {
  value: oneOf([ PriceModifierModes.PERCENT, PriceModifierModes.FIXED_PRICE]).isRequired,
  onChange: func.isRequired,
}